// ── Generated from swagger.json — do not edit by hand ────────────────────────
// Re-run `npm run generate:api` to regenerate after spec changes.

import { apiClient } from '@/lib/axios';
import type { AuthResponse, LoginRequest, MeResponse, RegisterRequest } from './model';

/**
 * POST /auth/register
 * Register with email and password.
 */
export const registerWithEmail = async (data: RegisterRequest): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>('/auth/register', data);
  return response.data;
};

/**
 * POST /auth/email-login
 * Login with email and password.
 */
export const loginWithEmail = async (data: LoginRequest): Promise<AuthResponse> => {
  const response = await apiClient.post<AuthResponse>('/auth/email-login', data);
  return response.data;
};

/**
 * GET /auth/me
 * Get current authenticated user info.
 */
export const getMe = async (): Promise<MeResponse> => {
  const response = await apiClient.get<MeResponse>('/auth/me');
  return response.data;
};

/**
 * GET /auth/whoop/connect
 * Start Whoop account connection (redirects to Whoop OAuth).
 * Returns the redirect URL; the browser should navigate to it.
 */
export const getWhoopConnectUrl = (): string => {
  return `${apiClient.defaults.baseURL ?? ''}/auth/whoop/connect`;
};

/**
 * DELETE /auth/whoop
 * Disconnect Whoop account.
 */
export const disconnectWhoop = async (): Promise<void> => {
  await apiClient.delete('/auth/whoop');
};
